
<form #mapForm="ngForm" autocomplete="off" class="server-dialog">
  <mat-form-field class="fullWidth" >
    <mat-label>Name</mat-label>
    <input matInput [(ngModel)]="data.name"  name="name" required maxlength="255" [disabled]="isEditMode">
    <mat-error>
      Name is <strong>required</strong>
    </mat-error>
  </mat-form-field>


  <mat-form-field class="fullWidth">
    <mat-label>Address</mat-label>
    <input matInput [(ngModel)]="data.address" name="address" required>
    <mat-error>
      Address is <strong>required</strong>
    </mat-error>
  </mat-form-field>

  <mat-form-field class="fullWidth">
    <mat-label>Port</mat-label>
    <input matInput [(ngModel)]="data.port" name="port" disabled>
  </mat-form-field>

  <mat-form-field class="fullWidth">
    <mat-label>Protocol (node -> router)</mat-label>
    <input matInput [(ngModel)]="data.protocol" name="protocol" disabled>
  </mat-form-field>

  <p *ngIf="showMemoryLimitationNotice" class="memory-limitation-notice">* The memory size of the routing server should be at least 16GB</p>


  <div id="routing-server-settings-advance-feature">
    <divider title="Advanced Settings"></divider>
    <mat-form-field class="fullWidth" *ngIf="isEditMode">
      <mat-label>Configurator - Routing Protocol</mat-label>
      <mat-select required [(ngModel)]="data.confRouterPort" name="confRouterPort" (selectionChange)="updateProtocol($event)">
        <mat-option *ngFor="let item of protocolList" [value]="item.value">
          {{item.text}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="fullWidth">
      <mat-label>Upgrade sequence</mat-label>
      <input matInput [(ngModel)]="data.upgradeSequence" type="number" min="1"
             max="2147483647" name="weight" [required]="isEditMode">
    </mat-form-field>
  </div>

  <divider title="Credentials"></divider>

  <mat-form-field class="fullWidth">
    <mat-label>
      <span class="device-before-arrow">Configurator </span><i class="fa fa-long-arrow-right fa-lg" aria-hidden="true"></i>
      <span class="device-after-arrow"> Router</span>
    </mat-label>
    <mat-select required [(ngModel)]="data.credentials" name="credentials">
      <mat-option *ngFor="let item of routerCredentialsOptions" [value]="item.id">
        {{item.description}}
      </mat-option>
    </mat-select>
 </mat-form-field>

  <mat-form-field class="fullWidth">
    <mat-label>
      <span class="device-before-arrow">Router </span><i class="fa fa-long-arrow-right fa-lg" aria-hidden="true"></i>
      <span class="device-after-arrow"> Configurator</span>
    </mat-label>
    <mat-select required [(ngModel)]="data.operator" name="operator" >
      <mat-option *ngFor="let item of routerUsersOptions" [value]="item.id">
        {{item.userName}}
      </mat-option>
    </mat-select>

  </mat-form-field>

  <divider title="WebSocket Tunnel"></divider>
  <p class="websocket">Enabled: <span [innerHTML]="data.tunEnabled | trueFalsePipe"></span></p>
  <mat-form-field class="fullWidth">
    <mat-label>Tunnel IP</mat-label>
    <input matInput [(ngModel)]="data.tunIpAddress" name="tunnelIP" disabled>
  </mat-form-field>

</form>














